import type {Element, Nodes} from 'hast'

export function isTag<T extends keyof HTMLElementTagNameMap>(node: Nodes, tagName: T): node is Element & {tagName: T} {
  return node.type === 'element' && node.tagName === tagName
}
